<div style="text-align: center; min-width: 300px">
  <div mat-dialog-content>
    <lemon-dialog-header>
      {{ header }}
    </lemon-dialog-header>

    @if (text.includes('\n')) {
      <!-- Preserve new lines -->
      <div style="white-space: pre-line">
        {{ text }}
      </div>
    } @else {
      <div>
        {{ text }}
      </div>
    }
  </div>
  <div mat-dialog-actions style="padding-left: 0; padding-right: 0">
    <app-lemonaid-secondary-button [focusRegionStart]="true" mat-dialog-close actionId="Oletko varma -dialog: Sulje">{{ leftAction }}</app-lemonaid-secondary-button>
    <span style="display: inline-block; width: 8vw; max-width: 4em"></span>
    <app-lemonaid-primary-button (click)="replyTrue()" actionId="Oletko varma -dialog: {{ header }} Valittiin: {{ rightAction }}">{{ rightAction }}</app-lemonaid-primary-button>
  </div>
</div>
